<template>
  <div
    class="[&>h4]:font-semibold [&>h4]:mb-2 [&>h4]:mt-6 [&>h4]:text-content-level-900 [&>h4]:text-sm [&>p]:leading-relaxed [&>p]:mb-4 dark:[&>h4]:text-content-inverse dark:text-content-level-300 max-w-none text-content-level-700 text-sm"
  >
    <p v-if="terms.preamble !== undefined && terms.preamble !== ''">
      {{ terms.preamble }}
    </p>

    <template
      v-for="clause in terms.clauses"
      :key="clause.title"
    >
      <h4 class="first:mt-0">
        {{ clause.title }}
      </h4>

      <p>{{ clause.body }}</p>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { LegalClauseTerms } from '~/composables/LegalClauseTerms'

defineProps<{
  /** The agreement text: an optional preamble followed by titled clauses. */
  terms: LegalClauseTerms
}>()
</script>
